import * as browserUtils from '@tolk-ai/browser-utils';
import * as genericUtils from '@tolk-ai/generic-utils';

var GetOneAgentConfigByBotIdErrors;

(function (GetOneAgentConfigByBotIdErrors) {
  GetOneAgentConfigByBotIdErrors[GetOneAgentConfigByBotIdErrors["inexistingBot"] = 0] = "inexistingBot";
})(GetOneAgentConfigByBotIdErrors || (GetOneAgentConfigByBotIdErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get GetOneAgentConfigByBotIdErrors () { return GetOneAgentConfigByBotIdErrors; }
});

var infrastructurePorts = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

const getOneAxiosAgentConfig = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('get', `/v1/bots/${botId}/connectors-config/agent`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingBot') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertAxiosAgentConfigToAgentConfig = botId => axiosAgentConfig => ({
  botId,
  status: axiosAgentConfig.status
});

const axiosGetOneAgentConfig = authenticatedRequest => async botId => {
  const axiosAgentConfig = await getOneAxiosAgentConfig(authenticatedRequest)(botId);
  return axiosAgentConfig === null ? null : convertAxiosAgentConfigToAgentConfig(botId)(axiosAgentConfig);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  axiosGetOneAgentConfig: axiosGetOneAgentConfig
});

const getOneMongodbAgentConfig = mongodb => async botId => mongodb.collection('api_bots').findOne({
  bot_id: botId
}, {
  projection: {
    apps: 1,
    bot_id: 1
  }
});

const convertMongodbAgentConfigToAgentConfig = mongodbAgentConfig => ({
  botId: mongodbAgentConfig.bot_id,
  status: Boolean(mongodbAgentConfig.apps.agent)
});

const getOneAgentConfigByBotId = mongodb => async botId => {
  const mongodbAgentConfig = await getOneMongodbAgentConfig(mongodb)(botId);
  return mongodbAgentConfig === null ? null : convertMongodbAgentConfigToAgentConfig(mongodbAgentConfig);
}; // eslint-disable-next-line import/prefer-default-export

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneAgentConfigByBotId: getOneAgentConfigByBotId
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	AgentConfig: {
		type: "object",
		properties: {
			botId: {
				$ref: "#/definitions/BotId"
			},
			status: {
				type: "boolean"
			}
		},
		required: [
			"botId",
			"status"
		],
		additionalProperties: false
	},
	AxiosAgentConfig: {
		type: "object",
		properties: {
			status: {
				type: "boolean"
			}
		},
		required: [
			"status"
		],
		additionalProperties: false
	},
	MongodbAgentConfig: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			apps: {
				type: "object",
				properties: {
					agent: {
						type: "object",
						properties: {
							accessToken: {
								type: "string"
							},
							accountId: {
								type: "string"
							},
							inboxId: {
								type: "string"
							}
						},
						required: [
							"accessToken",
							"accountId",
							"inboxId"
						],
						additionalProperties: false
					}
				},
				additionalProperties: false
			}
		},
		required: [
			"bot_id",
			"apps"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const getOneAgentConfig = getOneAgentConfigByBotId => async botId => {
  const agentConfig = await getOneAgentConfigByBotId(botId);
  return agentConfig === null ? GetOneAgentConfigByBotIdErrors.inexistingBot : agentConfig;
};

export { applicationPorts as appPorts, index$1 as axiosBotsRepository, index$2 as botModel, entitiesSchemas$1 as entitiesSchemas, getOneAgentConfig, infrastructurePorts as infraPorts, index as mongodbBotsRepository };
